export const ENDPOINT_PATH = '/api/v2/gateway';
